import { useImpersonationTarget } from '@/contexts/ImpersonationTargetContext';

/**
 * ¿La app está en solo lectura porque se está viendo como otro usuario?
 *
 * Es el mismo criterio del guard global de escrituras (`lib/impersonation/solo-lectura`):
 * hay un impersonado publicado en `ImpersonationTargetContext`. Sirve para que la UI
 * avise o deshabilite; la protección real es el guard, no este hook.
 */
export function useSoloLecturaVerComo(): boolean {
  return useImpersonationTarget() != null;
}
